import { render, staticRenderFns } from "./TkHotelFilter.vue?vue&type=template&id=5ff7f11c&"
import script from "./TkHotelFilter.vue?vue&type=script&lang=js&"
export * from "./TkHotelFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports